import { createFileRoute, redirect } from '@tanstack/react-router';
import { markWebPushPromptLoginIntent } from 'src/modules/notifications/hooks/push/web-push-prompt';
import {
  parseLoginSearch,
  startAuth0Login,
} from 'src/modules/shared/utils/auth0-login.util';

export const Route = createFileRoute('/login')({
  validateSearch: parseLoginSearch,
  beforeLoad: ({ context, search }) => {
    const { isAuthenticated, loginWithRedirect } = context.auth;
    const { email } = parseLoginSearch({ email: search.email });

    if (!isAuthenticated) {
      markWebPushPromptLoginIntent();
      // TanStack Router uses thrown promises for redirects in route guards.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw startAuth0Login(loginWithRedirect, email);
    }

    // TanStack Router uses thrown redirect objects in route guards.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/calls',
    });
  },
});
